/**
 * Adapter hooks
 * Hooks to access adapters from context
 */

import { useContext } from 'react'
import { AdapterContext } from './AdapterContext'
import type { ChatAdapters } from './types'

/**
 * Hook to access adapters from context
 */
export const useAdapters = (): ChatAdapters => {
  const context = useContext(AdapterContext)

  if (!context) {
    throw new Error('useAdapters must be used within AdapterProvider')
  }

  return context
}

/**
 * Individual adapter hooks for convenience
 */
export const useAuth = () => useAdapters().auth
export const useApi = () => useAdapters().api
export const useSocketAdapter = () => useAdapters().socket
export const useEnv = () => useAdapters().env
